export default __webpack_public_path__ + "static/media/star.999ada51.svg";